export default __webpack_public_path__ + "static/media/david13.6416b1ed.jpg";